(function(angular, module) {var NewMemberController, NewSlotFormController, SlotFormController, americorpsSlotFormDirective, dateInYear, findSlotInList, findSlotsForDate, getSlots, isSameSlot, newAmericorpsSlotDirective, newMemberDirective,
  bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

SlotFormController = (function() {

  /* @ngInject */
  function SlotFormController($q, $scope, ModelService, ModelConfig) {
    this.setInitialSlot = bind(this.setInitialSlot, this);
    this.setSlots = bind(this.setSlots, this);
    this.setGrantYears = bind(this.setGrantYears, this);
    this.q = $q;
    this.ModelService = ModelService;
    this.config = ModelConfig.getModelDatapoints('americorps_slot');
    getSlots(ModelService, this.programId).then(this.setGrantYears).then((function(_this) {
      return function(years) {
        return findSlotsForDate(years, _this.slot.amc_enrollment_date);
      };
    })(this)).then(this.setSlots).then(this.setInitialSlot);
    $scope.$watch(((function(_this) {
      return function() {
        var ref;
        return ((ref = _this.slot) != null ? ref.slot : void 0) != null;
      };
    })(this)), (function(_this) {
      return function(val) {
        if (!val) {
          return _this.setInitialSlot();
        }
      };
    })(this));
  }

  Object.defineProperties(SlotFormController.prototype, {
    date: {
      get: function() {
        var ref;
        return (ref = this.form) != null ? ref.formData.amc_enrollment_date : void 0;
      }
    },
    slotData: {
      get: function() {
        var ref;
        return (ref = this.form) != null ? ref.formData.slot : void 0;
      },
      set: function(value) {
        var ref;
        return (ref = this.form) != null ? ref.formData.slot = value : void 0;
      }
    }
  });

  SlotFormController.prototype.setGrantYears = function(grantYears) {
    this.grantYears = grantYears;
    return grantYears;
  };

  SlotFormController.prototype.setSlots = function(slots) {
    this.slots = slots;
    return slots;
  };

  SlotFormController.prototype.setInitialSlot = function() {
    var fakeSlot;
    fakeSlot = {
      year: this.slot.grant_year,
      type: this.slot.slot_type
    };
    return this.slot.slot = findSlotInList(fakeSlot, this.slots);
  };

  SlotFormController.prototype.dateChanged = function() {
    console.log(arguments);
    this.setSlots(findSlotsForDate(this.grantYears, this.date));
    this.slotData = findSlotInList(this.slotData, this.slots);
  };

  SlotFormController.prototype.normalizeData = function(data) {
    data.slot_type = data.slot.type;
    data.grant_year = data.slot.year;
    delete data.slot;
    return data;
  };

  SlotFormController.prototype.save = function(data) {
    if (data.slot == null) {
      return this.q.reject();
    }
    data = this.normalizeData(data);
    return this.doSave(data);
  };

  SlotFormController.prototype.doSave = function(data) {
    return this.ModelService.patchModel(this.slot, data).then(this.setInitialSlot);
  };

  SlotFormController.prototype.close = function() {
    this.onClose();
  };

  return SlotFormController;

})();

getSlots = function(ModelService, programId) {
  this.programId = programId;
  return ModelService.getRelation('program', this.programId, 'initiatives/slots');
};

dateInYear = function(date, year) {
  return !date.isBefore(year.start_date) && date.isBefore(year.end_date);
};

findSlotsForDate = function(grantYears, date) {
  var i, j, len, len1, ref, slot, slots, year;
  if (!(date != null ? date.isValid() : void 0)) {
    return [];
  }
  slots = [];
  for (i = 0, len = grantYears.length; i < len; i++) {
    year = grantYears[i];
    if (!dateInYear(date, year)) {
      continue;
    }
    ref = year.slots;
    for (j = 0, len1 = ref.length; j < len1; j++) {
      slot = ref[j];
      if (slot.total > 0) {
        slots.push(slot);
      }
    }
  }
  return slots;
};

findSlotInList = function(slot, slots) {
  var i, len, s;
  if (!slot || !slots) {
    return null;
  }
  for (i = 0, len = slots.length; i < len; i++) {
    s = slots[i];
    if (isSameSlot(s, slot)) {
      return s;
    }
  }
  return null;
};

isSameSlot = function(slot1, slot2) {
  return slot1.year === slot2.year && slot1.type === slot2.type;
};

NewSlotFormController = (function(superClass) {
  extend(NewSlotFormController, superClass);

  function NewSlotFormController($q, $scope, ModelService, ModelConfig) {
    this.slot = {};
    this.startOpen = true;
    this.title = 'Add AmeriCorps Slot ';
    NewSlotFormController.__super__.constructor.call(this, $q, $scope, ModelService, ModelConfig);
  }

  NewSlotFormController.prototype.doSave = function(data) {
    return this.ModelService.postRelation('participant', this.participantId, 'slots', data);
  };

  return NewSlotFormController;

})(SlotFormController);

NewMemberController = (function(superClass) {
  extend(NewMemberController, superClass);

  function NewMemberController($q, $scope, ModelService, ModelConfig) {
    this.slot = {};
    this.startOpen = true;
    this.showMemberName = true;
    this.title = 'Add AmeriCorps Member';
    NewMemberController.__super__.constructor.call(this, $q, $scope, ModelService, ModelConfig);
  }

  NewMemberController.prototype.doSave = function(data) {
    return this.ModelService.postRelation('program', this.programId, 'amc-members', data);
  };

  return NewMemberController;

})(SlotFormController);

newAmericorpsSlotDirective = function() {
  return {
    restrict: "E",
    templateUrl: 'students/americorps/americorpsSlotFormNew',
    scope: {},
    controller: NewSlotFormController,
    controllerAs: 'ctrl',
    bindToController: {
      participantId: '=',
      programId: '=',
      onClose: '&'
    }
  };
};

americorpsSlotFormDirective = function() {
  return {
    restrict: 'E',
    templateUrl: 'students/americorps/americorpsSlotFormNew',
    scope: {
      slot: '=',
      programId: '=',
      onClose: '&'
    },
    controller: SlotFormController,
    controllerAs: 'ctrl',
    bindToController: true
  };
};

newMemberDirective = (function(_this) {
  return function() {
    return {
      restrict: 'E',
      templateUrl: 'students/americorps/americorpsSlotFormNew',
      scope: {},
      controllerAs: 'ctrl',
      controller: NewMemberController,
      bindToController: {
        programId: '=',
        onClose: '&'
      }
    };
  };
})(this);

module.directive('dybNewAmericorpsSlotForm', newAmericorpsSlotDirective);

module.directive('dybAmericorpsSlotForm', americorpsSlotFormDirective);

module.directive('newAmericorpsMemberForm', newMemberDirective);
})(angular, angular.module("dybStudentAmc"));